import React from 'react';
import { compose } from 'redux';

// Components
import { InvitedChildLimits } from './containers/InvitedChildLimits';
import { FamilyChildPopup } from './containers/FamilyChildPopup';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const FamilyInvitedChild = () => (
  <>
    <InvitedChildLimits />
    <FamilyChildPopup />
  </>
);

export default compose(
  withViewAnalytics,
)(FamilyInvitedChild);
